// extracted by mini-css-extract-plugin
module.exports = {"menuitem":"MenuItem-module__menuitem___2-D4D","menuitemLink":"MenuItem-module__menuitemLink___3J7NZ","activeIndicator":"MenuItem-module__activeIndicator___19rLP"};